/**
 * Wrapper pour les nombres avec espaces / signes (+, -, etc.) qui doivent
 * rester en lecture LTR même dans un contexte RTL (arabe).
 *
 * Sans ce wrapper, "44 000" ou "+44 000" est réordonné par l'algorithme bidi
 * Unicode en "700 23" / "+700 23" en arabe car le moteur traite l'espace comme
 * un séparateur entre deux groupes.
 *
 * <bdi dir="ltr"> isole la portée et préserve l'ordre original des chiffres.
 *
 * Usage:
 *   <Num>44 000</Num>
 *   <Num>+44 000</Num>
 *   <Num>{count.toLocaleString("fr-FR")}</Num>
 */
export function Num({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <bdi dir="ltr" className={className} style={{ unicodeBidi: "isolate" }}>
      {children}
    </bdi>
  );
}
